export default defineNuxtPlugin({
  name: 'app:initialization',
  dependsOn: ['app:grpc-instance'],

  async setup({ $config }) {
    const globalStore = useGlobalStore()

    async function initializationGlobal() {
      await globalStore.initializationGlobal()
    }

    async function initializationServerOnly() {
      await globalStore.initializationServerOnly()
    }

    async function initializationClientOnly() {
      await globalStore.initializationClientOnly()
    }

    await initializationGlobal()

    await useServerOnlyAsync(initializationServerOnly)
    if (!$config.public.NUXT_SSR) {
      await initializationServerOnly()
    }

    await useClientOnlyAsync(initializationClientOnly)
  },
})
